import { DietsFormFields, AddUpdateDietDTO } from 'types';
import { InstitutionId } from 'types/institution/institution';

export const parseDietsFormFieldsIntoAddUpdateDietDTO = (
    dietData: DietsFormFields,
    institutionId: InstitutionId,
): AddUpdateDietDTO => {
    const { name, dateFrom, ...restData } = dietData;

    // Convert flat form fields back to mealPrices array
    const mealPricesArray = Object.entries(restData)
        .filter(
            ([key, value]) => key.startsWith('mealPrice_') && value !== null && value !== undefined,
        )
        .map(([key, price]) => ({
            mealTypeId: key.replace('mealPrice_', ''),
            name: '', // This will be filled by the backend
            price: price as number,
        }));

    const effectiveDate = dateFrom
        ? dateFrom.format('YYYY-MM-DD')
        : new Date().toISOString().split('T')[0];

    return {
        name,
        institutionId,
        dateFrom: effectiveDate,
        mealPrices: mealPricesArray,
    };
};
